import React from "react";
import PaymentDetailsContent from "src/components/payment-details-content/payment-details-content.component";
import HeaderComponent from "src/components/header/header.component";
import { PaymentProvider } from "src/store";

export default function PaymentDetailsPage() {
  return (
    <PaymentProvider>
      <HeaderComponent
        title="billing-details"
        subtitle="billind-details-subtitle"
        centered={true}
        displayMenu={true}
      />
      <PaymentDetailsContent />
    </PaymentProvider>
  );
}
